export const perPageOptions = [12, 30, 60];

export const defaultPageSize = perPageOptions[0];

